import { Outlet } from "react-router-dom";
import { Col, Row } from "antd";
import Logo from "@Assets/images/auth-logo.png";
import AuthImage from "@Assets/images/auth-image.png";

const UnAuthLayout = () => {
  return (
    <div className="min-h-screen bg-[#F6F1EA] flex items-center justify-center p-4">
      <div className="w-full max-w-[1400px]">
        <Row gutter={[24, 24]} className="h-[95vh]" align="middle">
          <Col
            xs={24}
            lg={12}
            className="flex items-center justify-center py-2"
            style={{ paddingLeft: "80px" }}
          >
            <div className="w-[532px] bg-white rounded-[18px] px-8 shadow-lg flex flex-col items-center justify-center pt-8">
              <div className="flex flex-col items-center mb-2">
                <img
                  src={Logo}
                  alt="Story Tree Logo"
                  className="w-[156px] mb-2"
                />
              </div>
              <div className="w-full max-w-[532px]">
                <Outlet />
              </div>
            </div>
          </Col>

          <Col xs={0} lg={12} className="h-full w-full">
            <div
              className="!h-full w-full rounded-[30px] shadow-lg bg-cover bg-center"
              style={{
                backgroundImage: `url(${AuthImage})`,
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default UnAuthLayout;
